import React, { useEffect } from "react";
import { Link } from "react-router-dom";

/** Pagina per gli indirizzi inesistenti: non indicizzabile, con le vie d'uscita. */
export default function NotFoundPage() {
  useEffect(() => {
    document.title = "Pagina non trovata | SC Dottori Commercialisti";
    const robots = document.createElement("meta");
    robots.name = "robots";
    robots.content = "noindex, follow";
    document.head.appendChild(robots);
    return () => robots.remove();
  }, []);

  const link = "text-gold hover:text-[#96742F] underline underline-offset-4";

  return (
    <div className="min-h-[70vh] bg-[#FAF8F5] flex items-center px-6 py-24" data-testid="not-found-page">
      <div className="max-w-2xl">
        <p className="text-xs tracking-[0.25em] text-gold uppercase mb-4">Errore 404</p>
        <h1 className="font-heading text-4xl sm:text-5xl lg:text-6xl text-[#0D1527] leading-none mb-6">
          Questa pagina non esiste
        </h1>
        <p className="text-[#4A5568] text-base leading-relaxed mb-10">
          L'indirizzo che hai aperto non corrisponde a nessuna pagina del sito: forse il link era
          incompleto, oppure la pagina è stata spostata. Da qui puoi ripartire.
        </p>
        <ul className="space-y-3 text-base">
          <li><Link className={link} to="/" data-testid="nf-home">Home</Link> — chi siamo e come lavoriamo</li>
          <li><Link className={link} to="/metodo" data-testid="nf-metodo">Il metodo del controllo direzionale</Link></li>
          <li><Link className={link} to="/servizi" data-testid="nf-servizi">I servizi dello studio</Link></li>
          <li><Link className={link} to="/strumenti" data-testid="nf-strumenti">Gli strumenti in Excel</Link></li>
          <li><Link className={link} to="/approfondimenti" data-testid="nf-blog">Gli approfondimenti</Link></li>
          <li><Link className={link} to="/contatti" data-testid="nf-contatti">Contatti</Link></li>
        </ul>
      </div>
    </div>
  );
}
